import classNames from 'classnames'
import { ReactElement, ComponentType } from 'react'

export function EmptySearch({
  title,
  description,
  className,
  titleSize = `sm`,
  icon: Icon,
}: {
  title: string
  description?: string | ReactElement
  className?: string
  titleSize?: `sm` | `md` | `lg`
  icon: ComponentType
}): ReactElement {
  return (
    <div className={classNames(`flex flex-col items-center gap-y-2 space-y-2 align-middle`, className)}>
      <div className="text-default">
        <Icon />
      </div>
      <span
        className={classNames(
          `text-strong`,
          { 'text-heading-sm': titleSize === `sm` },
          { 'text-heading-md': titleSize === `md` },
          { 'text-center text-heading-xl font-semibold md:text-left': titleSize === `lg` },
        )}
      >
        {title}
      </span>
      {description && <p className="whitespace-pre-line text-center text-body-sm text-subtle">{description}</p>}
    </div>
  )
}
